import React, { useState } from "react";
import Box from "@mui/material/Box";
import Backdrop from "@mui/material/Backdrop";
import SpeedDial from "@mui/material/SpeedDial";
import AddIcon from "@mui/icons-material/Add";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import "./FloatingSpeedDial.scss";

import AddProducts from "./AddProducts"; // normal product form
import AddSubscription from "./subscription/AddSubscription"; // subscription form
import { useAuthContext } from "../firebase-files/hooks/useAuthContext";

const AddProductsTwo = () => {
  const { user } = useAuthContext();

  // Debug: log the user object to verify the role
  console.log("Current user:", user);

  const [open, setOpen] = useState(false);
  const [showNormalProductForm, setShowNormalProductForm] = useState(false);
  const [showSubscriptionForm, setShowSubscriptionForm] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const updatedActions = [
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24px"
          viewBox="0 -960 960 960"
          width="24px"
          fill="currentColor"
        >
          <path d="M200-640v440h560v-440H640v320l-160-80-160 80v-320H200Zm0 520q-33 0-56.5-23.5T120-200v-499q0-14 4.5-27t13.5-24l50-61q11-14 27.5-21.5T250-840h460q18 0 34.5 7.5T772-811l50 61q9 11 13.5 24t4.5 27v499q0 33-23.5 56.5T760-120H200Zm16-600h528l-34-40H250l-34 40Zm184 80v190l80-40 80 40v-190H400Zm-200 0h560-560Z" />
        </svg>
      ),
      name: "Add Products",
      action: () => {
        console.log("Normal Products action clicked");
        setShowNormalProductForm(true);
        handleClose();
      },
    },
    // {
    //   icon: (
    //     <svg
    //       xmlns="http://www.w3.org/2000/svg"
    //       height="24px"
    //       viewBox="0 -960 960 960"
    //       width="24px"
    //       fill="currentColor"
    //     >
    //       <path d="M160-80q-33 0-56.5-23.5T80-160v-400q0-33 23.5-56.5T160-640h640q33 0 56.5 23.5T880-560v400q0 33-23.5 56.5T800-80H160Zm0-80h640v-400H160v400Zm240-40 240-160-240-160v320ZM160-680v-80h640v80H160Zm120-120v-80h400v80H280ZM160-160v-400 400Z" />
    //     </svg>
    //   ),
    //   name: "Add Subscription",
    //   action: () => {
    //     console.log("Subscription action clicked");
    //     setShowSubscriptionForm(true);
    //     handleClose();
    //   },
    // },
  ];

  // Robust role check: handles whitespace and case
  const isAdmin =
    user &&
    typeof user.role === "string" &&
    ["admin", "superadmin"].includes(user.role.trim().toLowerCase());

  return (
    <div className="floating_Speed_dial_icon" style={{ bottom: "100px" }}>
      {isAdmin ? (
        <>
          <Box sx={{ height: 330, transform: "translateZ(0px)", flexGrow: 1 }}>
            <Backdrop open={open} />
            <SpeedDial
              ariaLabel="SpeedDial tooltip example"
              sx={{ position: "absolute", bottom: 30, right: 1 }}
              icon={<AddIcon />}
              onClose={handleClose}
              onOpen={handleOpen}
              open={open}
            >
              {updatedActions.map((action) => (
                <SpeedDialAction
                  key={action.name}
                  icon={action.icon}
                  tooltipTitle={action.name}
                  tooltipOpen
                  onClick={action.action}
                />
              ))}
            </SpeedDial>
          </Box>

          {/* Render Normal Product modal */}
          {showNormalProductForm && (
            <AddProducts
              isModalOpen={showNormalProductForm}
              closeModal={() => setShowNormalProductForm(false)}
            />
          )}

          {/* Render Subscription modal */}
          {showSubscriptionForm && (
            <AddSubscription
              isModalOpen={showSubscriptionForm}
              closeModal={() => setShowSubscriptionForm(false)}
            />
          )}
        </>
      ) : null}
    </div>
  );
};

export default AddProductsTwo;
